import React from 'react';
import { Col, Button } from "react-bootstrap"
import "./SecondRow.css"

import { useGlobalState } from '../../../config/routes';

import GO from '../../../assets/GO/Grand Opening 1.0 (Personal).png'

const NSF = "https://www.amway.ca/medias/NSFContents.svg?context=bWFzdGVyfHJvb3R8NzU2N3xpbWFnZS9zdmcreG1sfGg3Mi9oOTQvODkxNDYyMDY3ODE3NC5zdmd8MGFkNzMyZTY3MmYxZDk4NzI0ZGQ1ODljZjg3NzU1NDIwNTBhMzgzODY5ZmZmNjA3OGZiMzhkODBhMzc2N2UwZQ"

const Halal = "https://www.amway.ca/medias/Halal.svg?context=bWFzdGVyfHJvb3R8MTQ2NXxpbWFnZS9zdmcreG1sfGgzMS9oYjAvODkxNDYyMDM1MDQ5NC5zdmd8Mzk1MzI0YTAyMjliYmUyMDAxN2UxNmVjZjA4Y2VmNzRkZjY4ZTU2Yzc2MTM2OTlkNzcwZjVmZjAzMWZjYTJjNA"

const Kosher =  "https://www.amway.ca/medias/Kosher.svg?context=bWFzdGVyfHJvb3R8ODU3fGltYWdlL3N2Zyt4bWx8aDY2L2g0YS84OTE0NjIwNTQ3MTAyLnN2Z3w2OWY3NGE0NzA4YzFlYzMyMTcyZWVlN2MxMDNkZGYxYTBjMTI2NTlhNzE0NTQzM2ZkMDYyYTY5MGQwMTBkNjc2"

const NutriCert = "https://www.amway.ca/medias/NutriCert.svg?context=bWFzdGVyfHJvb3R8Njk5MHxpbWFnZS9zdmcreG1sfGg5Yi9oODYvODkxNDYyMDgwOTI0Ni5zdmd8N2IzOTg0NGE3Yjg1ZTAwZjA5NzQ2NjhiZDIzYmUzNTgwZmUwMmVlZDIxODdiNDhjYzE5NzIzM2E3YTFmYjZlNQ"

const NonGMO = "https://www.amway.ca/medias/NonGMOVerified.svg?context=bWFzdGVyfHJvb3R8OTY1MXxpbWFnZS9zdmcreG1sfGhkYS9oZTcvOTMxMTk2MzE1MjQxNC5zdmd8NmZhMjcyOWMwYWNiNTlhYjkyZDY3YWUzMjk3NDZiOTJjMDY4ZWQ2OTZhNzViMzQ4ODVkMTFjMmQ2MDA0NTBkZg"

const USDA = "https://www.amway.ca/medias/USDAOrganic.svg?context=bWFzdGVyfHJvb3R8NDEyNHxpbWFnZS9zdmcreG1sfGg3ZS9oOTUvOTM0MDI3MzU1NzUzNC5zdmd8ZDA3ZjFlZGYwZTgzYzQ4OGFlN2RkZmZhOTQ4MmU3ZDQxZGNmNGU4Nzg3MmRkNGMyMDUxZjkwNzZhOWI4MjNmMA"




// import CleanResume from "../../../assets/docs/Clean Resume.pdf"

const CenterColumn = () => {

    const { isBusinessVisible } = useGlobalState();

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = "https://athan-d719.github.io/src/Clean%20Resume.pdf"; // Change the path accordingly
        link.download = 'Clean Resume.pdf'; // Set the desired file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    //Updated Date
    // const [updatedDate, setStartDateTime] = useState('');

    // useEffect(() => {
    //     setStartDateTime(new Date(Date.now()));
    // });

    return (
        <Col className={(isBusinessVisible ? " " : "") +'col-12 col-sm-4 firstThird_container'} >
            <h1>Upcoming Events</h1>
            <div className="columns_grid p-4">
                 <div className="col d-flex first_education">
                    <a>
                        <img src={GO} 
                        className="card-img border rounded" alt="GO" />
                    </a>
                </div>
                {/* <p><b>EMAIL: </b>jondiaz719@gmail.com</p>
                <p><b>LANGUAGE: </b>English, Spanish, French</p>
                <p><b>CURRENT RESIDENCE: </b>Canada</p>
                <p><b>AVAILABLE: </b>To Work</p>
                <p><b>UPDATED ON:</b> 2024-05-05</p> */}
            </div>

            {/* <Col className={(isBusinessVisible ? " " : "") +'col-12 col-sm-4 thirdThird_container'}>
                    <h1>Upcoming Events</h1>
                    
                    <Carousel>
                    <Carousel.Item interval={4000}>
                    
                        <a href='https://www.amway.ca/en_CA/myshop/NathansCorner' target='blank'>
                        <img src={DoubleX} alt="First slide" className='products-carousel'/>
                        </a>
                        
                    </Carousel.Item>
                    <Carousel.Item interval={4000}>
                        <a href='https://www.amway.ca/en_CA/myshop/NathansCorner' target='blank'>
                            <img src={XSMuscleMultiplierBundle} alt="Second slide" className='products-carousel'/>
                        </a>
                        
                    </Carousel.Item>
                    <Carousel.Item interval={4000}>
                        <a href='https://www.amway.ca/en_CA/myshop/NathansCorner' target='blank'>
                            <img src={SleepGummies} alt="Third slide" className='products-carousel'/>
                        </a>

                    </Carousel.Item>
                    <Carousel.Item interval={4000}>
                        <a href='https://www.amway.ca/en_CA/myshop/NathansCorner' target='blank'>
                            <img src={XSVarietyPack} alt="Forth slide" className='products-carousel'/>
                        </a>

                    </Carousel.Item>
                    </Carousel>
                    
                    <div className='d-flex justify-content-around'>
                    </div>

        </Col> */}
        </Col>


                

    );
};

export default CenterColumn;
